import React, { memo } from 'react';
import SpaceItem, { Space } from '../common/SpaceItem';

interface StarredSpaceItemProps {
  space: Space;
  onUnstar: (id: string) => void;
  onClick?: (id: string) => void;
}

/**
 * resuable ui item to render the list
 * @param param0
 * @returns
 */
const StarredSpaceItem = ({
  space,
  onUnstar,
  onClick,
}: StarredSpaceItemProps) => {
  return (
    <SpaceItem
      space={space}
      isStarred
      onStarToggle={onUnstar}
      onClick={onClick}
    />
  );
};

export default memo(StarredSpaceItem);
